/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TaxIdMappingRulesIdDelete$Params {
  id: string;
  'Active-Tenant-Identifier': string;
}

export function taxIdMappingRulesIdDelete(http: HttpClient, rootUrl: string, params: TaxIdMappingRulesIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, taxIdMappingRulesIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

taxIdMappingRulesIdDelete.PATH = '/tax-id-mapping-rules/{id}';
